import pageStyle from "./index.module.less";
import LangSelect from "@/components/langSelect";
import TimePicker from "@/components/timePicker";
import ChannelSelect from "@/components/channelSelect/index";
import DataSet from "@antv/data-set";
import { getImSessionAnalysis } from "../service";
import i18n from "@/i18n";
import AgentGroup from "@/views/ticket/components/agentGroup";

export default {
    name: "DataImAll",
    data() {
        return {
            pageStyle,
            query: {
                language: "",
                time: [],
                skill_group_id: "",
                channels: ""
            },
            tableData: [],
            lineData: [],
            cvData: [],
            visible: false,
            labelConfig: [
                "percent",
                {
                    formatter: (val, item) => {
                        return item.point.user_feedback + ": " + val;
                    }
                }
            ],
            pieStyle: {
                stroke: "#fff",
                lineWidth: 1
            },
            cardData: [
                {
                    value: 0,
                    title: i18n.t("data.imall.chats"),
                    _index: "data.imall.chats"
                },
                {
                    value: 0,
                    title: i18n.t("data.imall.avg"),
                    _index: "data.imall.avg"
                },
                {
                    value: 0,
                    title: i18n.t("data.imall.avgtime"),
                    _index: "data.imall.avgtime"
                },
                {
                    value: 0,
                    title: i18n.t("data.imall.satisfaction"),
                    _index: "data.imall.satisfaction"
                }
            ]
        };
    },

    components: { LangSelect, TimePicker, AgentGroup, ChannelSelect },
    watch: {
        "$i18n.locale"() {
            this.queryList();
        },
        query: {
            deep: true,
            handler() {
                this.queryList();
            }
        }
    },

    methods: {
        async queryList() {
            let { list, allData, lineData } = await getImSessionAnalysis({
                end_time: this.query.time[1],
                start_time: this.query.time[0],
                language: this.query.language,
                skill_group_id: this.query.skill_group_id,
                channels: this.query.channels
            });
            this.tableData = list;
            this.cardData = this.cardData.map((value, index) => {
                return {
                    value: allData[index],
                    title: i18n.t(value._index),
                    _index: value._index
                };
            });
            this.lineData = lineData;
        },
        channelSelect(data) {
            this.query.channels = data;
        },
        async handleClick(value) {
            const data = new DataSet.View().source(value.data);

            data.transform({
                type: "percent",
                field: "num",
                dimension: "reason",
                as: "percent"
            });

            this.cvData = data.rows;
            this.visible = true;
        }
    }
};
